/**
 * @module api/exclusiveApi/exclusiveLakuPandaiApi
 */

import secureClient from 'lib/secure-client';
import exclusiveUrl from 'shared_js/helpers/urlHelper/exclusiveUrl';

/**
 * Inquiry User Status
 * https://blueprint.bukalapak.io/exclusive/t/mitra-send-money~mitra~send~money~put~exclusive~mitra-send-money~user
 */
function inquiryUserMitraSendMoney() {
  return this.put(`${exclusiveUrl}/mitra-send-money/user`, 'user');
}

/**
 * Get Mitra Send Money User Segments
 * https://blueprint.bukalapak.io/exclusive/t/mitra~send~money~mitra~send~money~get~exclusive~mitra-send-money~user~segments
 */
function getMitraSendMoneyUserSegments() {
  return this.get(`${exclusiveUrl}/mitra-send-money/users/segments`, 'user');
}

/**
 * Get Mitra Send Money Banks
 *
 */
function getMitraSendMoneyBanks() {
  return this.get(`${exclusiveUrl}/mitra-send-money/banks`, 'user');
}

/**
 * Get Mitra Send Money Available Partners
 * https://blueprint.bukalapak.io/exclusive/t/mitra-send-money~mitra~send~money~get~exclusive~mitra-send-money~available-partners
 */
function getMitraSendMoneyAvailablePartners(params) {
  return this.get(
    `${exclusiveUrl}/mitra-send-money/available-partners`,
    'user',
    { params },
  );
}

/**
 * Get Mitra Send Money Available Partners
 * https://blueprint.bukalapak.io/exclusive/t/mitra-send-money~mitra~send~money~get~exclusive~mitra-send-money~performance-indicator
 */
function getMitraSendMoneyPerformanceIndicator() {
  return this.get(
    `${exclusiveUrl}/mitra-send-money/performance-indicator`,
    'user',
  );
}

/**
 * Get Mitra Send Money Reference Numbers
 *
 */
function getMitraSendMoneyRefNumber(params) {
  return this.get(
    `${exclusiveUrl}/mitra-send-money/reference-numbers`,
    'user',
    { params },
  );
}

/**
 * Retrieve Mitra Send Money User List base on params filter
 *
 * @param {number} params.limit - e.g. 20
 * @param {number} params.offset - e.g. 0
 * @param {number} params.keywords - e.g. hajinawiganteng
 *
 */

function retrieveSendMoneyUserList(params) {
  return this.get(`${exclusiveUrl}/mitra-send-money/users`, 'user', { params });
}

/**
 * Retrieve Mitra Send Money Trx List base on params filter
 *
 * @param {number} params.limit - e.g. 20
 * @param {number} params.offset - e.g. 0
 * @param {number} params.invoice_id - e.g. 77777777
 * @param {String} params.status - e. 'pending'
 *
 */

function retrieveSendMoneyTrxList(params) {
  return this.get(
    `${exclusiveUrl}/mitra-lakupandai/admins/digital-send`,
    'user',
    {
      params,
    },
  );
}

/**
 * Update send money transaction (reprocess, remit, refund)
 *
 * @param {number} id - e.g. 20
 * @param {String} params.action - e.g. 'reprocess'
 * @param {String} params.notes - e.g. 'This is notes'
 *
 */
function updateSendMoneyTrx(id, params) {
  return this.post(
    `${exclusiveUrl}/mitra-lakupandai/admins/digital-send/${id}/update`,
    'user',
    {
      data: params,
      responseErrorJson: true,
    },
  );
}

/**
 * Bulk update send money transaction (reprocess, remit, refund)
 * https://blueprint.bukalapak.io/exclusive/t/mitra-lakupandai~lakupandai~admin~api~post~exclusive~mitra-lakupandai~admins~digital-send~bulk-update
 */
function bulkUpdateSendMoneyTrx(params) {
  return this.post(
    `${exclusiveUrl}/mitra-lakupandai/admins/digital-send/bulk-update`,
    'user',
    {
      data: params,
      responseErrorJson: true,
    },
  );
}

/**
 * Get Mitra Send Money Service Fee
 *
 */

function retrieveSendMoneyServiceFee() {
  return this.get(`${exclusiveUrl}/mitra-send-money/service-fees`, 'user');
}
/**
 * update Mitra Status
 *
 * @param {Object} params
 * @param {string} params.status - status e.g 'approved'
 * @param {object} params.phone - phone, e.g. '08982192812 '
 * @param {string} params.kyc_source - kyc source e.g 'digital-send' or 'international withdraw'
 */

function updateMitraStatus(params) {
  return this.patch(`${exclusiveUrl}/mitra-send-money/user`, 'user', {
    data: params,
  });
}

/**
 * Beneficiary Account Inquiry
 *
 * @param {Object} params
 * @param {string} params.transmission_time - trx time e.g '2019-10-24T14:06:04Z'
 * @param {string} params.stan - stan, e.g. '899852 '
 * @param {string} params.reference_number - ref number, e.g. '190000000001 '
 * @param {object} params.beneficiary
 * @param {string} params.beneficiary.bank_key - bank key, e.g. 'mandiri '
 * @param {string} params.beneficiary.account_no - account number, e.g. '123456789 '
 *
 */
function inquiryBenefeciaryAccount(params, newInquiryEndpoint = false) {
  if (newInquiryEndpoint) {
    return this.post(`${exclusiveUrl}/mitra-send-money/banks/inquiry`, 'user', {
      data: params,
      responseErrorJson: true,
    });
  }

  return this.post(`${exclusiveUrl}/mitra-send-money/bank-inquiry`, 'user', {
    data: params,
    responseErrorJson: true,
  });
}

/**
 * Retrieve Service Fee and Toggle Status
 *
 */
function retrieveServiceFeeAndToggleStatus() {
  return this.get(
    `${exclusiveUrl}/mitra-send-money/service-fee-settings`,
    'user',
  );
}

/**
 * Update Service Fee and Toggle Status
 *
 */
function updateServiceFeeAndToggleStatus(params) {
  return this.patch(
    `${exclusiveUrl}/mitra-send-money/service-fee-settings`,
    'user',
    {
      data: params,
    },
  );
}

/**
 *Bulk Insert/Update Mitra Send Money User
 *
 * @param {Object} params
 * @param {string} params.attachment - trx time e.g 'data:text/csv;base64,dXNlcm5hbWUsIHN0YXR1cywgcmVhc29uCnVzZXIwMDEsIGFwcHJvdmVkLCByZWFzb24gdGVzdCAxCnVzZXIwMDIsIHJlamVjdGVkLCByZWFzb24gdGVzdCAyCnVzZXIwMDMsIHBlbmRpbmcsIHJlYXNvbiB0ZXN0IDMKdXNlcjAwNCwgbmV3LCByZWFzb24gdGVzdCA0'
 * @param {string} params.attachment_file_name - stan, e.g. 'dispossessed.csv'
 *
 */
function updateMitraSendMoneyUsers(params) {
  return this.post(`${exclusiveUrl}/mitra-send-money/users`, 'user', {
    data: params,
  });
}

/**
 * Retrieve User's Dana Profile
 *
 */
function retrieveDanaProfile() {
  return this.get(`${exclusiveUrl}/e-wallets/dana/profile`, 'user');
}

/**
 * Retrieve Sendmoney's Trx List for Download data purpose
 *
 * @param {Object} params
 * @param {string} params.remote_id - remote id e.g '123,
 * @param {string} params.invoice_id - invoice id e.g '121341',
 * @param {string} params.status - status e.g 'pending',
 * @param {string} params.start_date - start date  e.g '1581094800000',
 * @param {string} params.end_date - end data, e.g. '158109480000121'
 *
 */
function downloadSendMoneyTrxListByFilter(params) {
  return this.get(
    `${exclusiveUrl}/mitra-lakupandai/admins/digital-send/downloads`,
    'user',
    { params },
  );
}

/**
 * Request Digital-Send Transaction
 *
 * @param {Object} headers
 * @param {string} headers.Bukalapak-Idetity - bukalapak identity, '117361FE-2EED-43BA-AF07-1B4056D303B5'
 * @param {string} headers.Bukalapak-OTP - bukalapak otp, '12345'
 * @param {string} headers.Bukalapak-OTP-Key - bukalapak otp key, '47c5495e-fb2c-4267-a896-23014afc7505'
 * @param {string} headers.Bukalapak-OTP-Device-ID - bukalapak device Id, 'ASD223SDA
 * @param {string} headers.Bukalapak-OTP-Method - bukalapak OTP method - 'sms',
 * @param {Object} params
 * @param {string} params.transaction_type - transaction type, 'digital-send'
 * @param {string} params.method - payment method, 'wallet'
 * @param {string} params.voucher_code - voucher code optional, e.g. 'MITRABUKALAPAK'
 * @param {object} params.transaction_id - transaction id optional, e.g '12'
 * @param {string} params.final_amount - final amount include transaction amount and service fee, e.g. '52000'
 * @param {Object} params.payload
 * @param {string} params.payload.beneficiary
 * @param {string} params.payload.beneficiary.bank_key - bank, e.g. 'bca'
 * @param {string} params.payload.beneficiary.account_no - account number, e.g. '123456789 '
 * @param {string} params.payload.beneficiary.name - account name, e.g. 'fulanah'
 * @param {Object} params.payload.sender
 * @param {string} params.payload.sender.phone - sender phone number, e.g. '08123456789 '
 * @param {string} params.payload.sender.nik - sender nik, e.g. '12345678901113 '
 * @param {string} params.payload.transmission_time - trx time e.g '2019-10-24T14:06:04Z'
 * @param {string} params.payload.stan - stan, e.g. '899852 '
 * @param {string} params.payload.reference_number - reference number, e.g. '123456789 '
 */
// TODO late will remove this and using requestDigitalTransaction on exclusiveDigitalTransactionApi
function requestDigitalSendTransaction(headers, params) {
  return this.post(`${exclusiveUrl}/mitra-payment/transactions`, 'user', {
    headers,
    data: params,
  });
}

/**
 * Set Lakupandai Activation Status
 * Blueprint: https://blueprint.bukalapak.io/exclusive/t/mitra-lakupandai~lakupandai~general~api~post~exclusive~mitra-lakupandai~activations~feature
 *
 * @param {string} - feature type id e.g 'digital-send' or 'international withdraw',
 *
 */
function saveActivationStatus(feature) {
  return this.post(
    `${exclusiveUrl}/mitra-lakupandai/activations/${feature}`,
    'user',
  );
}

/**
 * Create user trial
 * Blueprint: https://blueprint.bukalapak.io/exclusive/t/mitra-lakupandai~lakupandai~general~api~post~exclusive~mitra-lakupandai~users~trial
 */
function createUserTrial() {
  return this.post(`${exclusiveUrl}/mitra-lakupandai/users/trial/`, 'user');
}

/**
 * Retrieve KYC Identity
 * Blueprint: https://blueprint.bukalapak.io/exclusive/t/single~kyc~single~kyc~identity~get~exclusive~single-kycs~identities~me
 */
function retrieveSingleKycIdentity() {
  return this.get(`${exclusiveUrl}/single-kycs/identities/me/`, 'user');
}

/**
 * Request Digital-Send Transaction (Buka20 OOM Payment domain)
 * https://blueprint.bukalapak.io/exclusive/t/mitra-send-money~mitra~send~money~post~exclusive~mitra-send-money~transaction
 *
 * @param {Object} headers
 * @param {string} headers.Bukalapak-Idetity - bukalapak identity, '117361FE-2EED-43BA-AF07-1B4056D303B5'
 * @param {string} headers.Bukalapak-OTP - bukalapak otp, '12345'
 * @param {string} headers.Bukalapak-OTP-Key - bukalapak otp key, '47c5495e-fb2c-4267-a896-23014afc7505'
 * @param {string} headers.Bukalapak-OTP-Device-ID - bukalapak device Id, 'ASD223SDA
 * @param {string} headers.Bukalapak-OTP-Method - bukalapak OTP method - 'sms',
 * @param {Object} params
 * @param {string} params.total_amount - final amount include transaction amount and service fee, e.g. '52000'
 * @param {string} params.amount - total amount include transaction amount and service fee, e.g. '52000'
 * @param {string} params.beneficiary
 * @param {string} params.beneficiary.bank_key - bank, e.g. 'bca'
 * @param {string} params.beneficiary.account_no - account number, e.g. '123456789 '
 * @param {string} params.beneficiary.name - account name, e.g. 'fulanah'
 * @param {Object} params.sender
 * @param {string} params.sender.phone - sender phone number, e.g. '08123456789 '
 * @param {string} params.sender.nik - sender nik, e.g. '12345678901113 '
 * @param {string} params.sender.trx_purpose - purpose for the trx, eg. 'customer transfer'
 * @param {string} params.transmission_time - trx time e.g '2019-10-24T14:06:04Z'
 * @param {string} params.stan - stan, e.g. '899852 '
 * @param {string} params.reference_number - reference number, e.g. '123456789'
 * @param {string} params.referral_code - referral code, e.g. '12912'
 * @param {string} params.voucher_code - voucher code, e.g. 'VOUCHERCODE'
 * @param {string} params.method - voucher code, e.g. 'wallet'
 * @param {string} params.latitude - location user latitude, e.g. 123.45
 * @param {string} params.longitude - location user longitude, e.g. 67.89
 */
function createDigitalSendBuka20Transaction(headers, params) {
  return this.post(`${exclusiveUrl}/mitra-send-money/transaction`, 'user', {
    headers,
    data: params,
  });
}

/**
 * Retrieve Kirim Uang transaction monthly summaries
 * Blueprint: https://blueprint.bukalapak.io/exclusive/t/mitra-send-money~mitra~send~money~get~exclusive~mitra-send-money~transactions~summaries
 */
function retrieveMitraSendMoneyTransactionSummaries({
  number_of_months: NumberOfMonths,
}) {
  return this.get(
    `${exclusiveUrl}/mitra-send-money/transactions/summaries?number_of_months=${NumberOfMonths}`,
    'user',
  );
}

/**
 * Retrieve Most Frequently Used Bank Accounts
 * Blueprint: https://blueprint.bukalapak.io/exclusive/t/mitra-send-money~mitra~send~money~get~exclusive~mitra-send-money~most-frequently-used-bank-accounts
 */
function retrieveMostFrequentlyUsedBankAccounts() {
  return this.get(
    `${exclusiveUrl}/mitra-send-money/most-frequently-used-bank-accounts`,
    'user',
  );
}

/**
 * Collection of exclusive LakuPandai Send Money Api
 */
const exclusiveMitraSendMoneyApi = secureClient(
  {
    inquiryUserMitraSendMoney,
    getMitraSendMoneyUserSegments,
    retrieveSendMoneyUserList,
    getMitraSendMoneyBanks,
    getMitraSendMoneyAvailablePartners,
    getMitraSendMoneyPerformanceIndicator,
    getMitraSendMoneyRefNumber,
    inquiryBenefeciaryAccount,
    retrieveSendMoneyServiceFee,
    updateMitraStatus,
    retrieveDanaProfile,
    requestDigitalSendTransaction,
    updateMitraSendMoneyUsers,
    retrieveSendMoneyTrxList,
    updateSendMoneyTrx,
    bulkUpdateSendMoneyTrx,
    downloadSendMoneyTrxListByFilter,
    retrieveServiceFeeAndToggleStatus,
    updateServiceFeeAndToggleStatus,
    saveActivationStatus,
    createUserTrial,
    retrieveSingleKycIdentity,
    createDigitalSendBuka20Transaction,
    retrieveMitraSendMoneyTransactionSummaries,
    retrieveMostFrequentlyUsedBankAccounts,
  },
  'xhrExclusiveMitraSendMoneyApi',
);

export default exclusiveMitraSendMoneyApi;
